/**
 * Reducer helper for fetching the signing url (success).
 *
 * @method fetchSigningUrlSuccess
 * @param  {Object}               state  The current state
 * @param  {Object}               action The fired action
 * @return {Object}                      The updated state
 */
export function fetchSigningUrlSuccess(state, action) {
    return {
        ...state
    };
}

/**
 * Reducer helper for fetching the signing url and loading the iFrame (success).
 *
 * @method loadSigningIframeSuccess
 * @param  {Object}                            state  The current state
 * @param  {Object}                            action The fired action
 * @return {Object}                                   The updated state
 */
export function loadSigningIframeSuccess(state, action) {
    return {
        ...state
    };
}

/**
 * Reducer helper for fetching the PDF and signing url (success).
 *
 * @method fetchPdfAndSigningUrlSuccess
 * @param  {Object}                            state  The current state
 * @param  {Object}                            action The fired action
 * @return {Object}                                   The updated state
 */
export function fetchPdfAndSigningUrlSuccess(state, action) {
    return {
        ...state,
        info: {
            ...action.payload.info
        }
    };
}

/**
 * Reducer helper for fetching the PDF and signing url (success).
 *
 * @method fetchPdfUrlSuccess
 * @param  {Object}                            state  The current state
 * @param  {Object}                            action The fired action
 * @return {Object}                                   The updated state
 */
export function fetchPdfUrlSuccess(state, action) {
    return {
        ...state
    };
}

/**
 * Reducer helper for validate token (success).
 *
 * @method validateTokenSuccess
 * @param  {Object}                            state  The current state
 * @param  {Object}                            action The fired action
 * @return {Object}                                   The updated state
 */
export function validateTokenSuccess(state, action) {
    return {
        ...state,
        info: {
            ...action.payload.info
        }
    };
}
